import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleData } from '@/common/types/roles'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { RoleValidationSchema } from '@/features/clientRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateClientRoleProps {
  roleId: string
  initialRole?: RoleData
  onSuccess: () => void
  onError: (error: any) => void
}

export const useUpdateClientRole = ({
  roleId,
  initialRole,
  onSuccess,
  onError,
}: UseUpdateClientRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateClientRole'],
    mutationFn: async ({
      form,
      selectedPermissions,
    }: {
      form: RoleValidationSchema
      selectedPermissions: { permission_id: string }[]
    }) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        permission_roles_attributes: getRailsUpdate(
          initialRole?.permission_roles || [],
          selectedPermissions,
          (value) => value.permission.id,
          (value) => value.permission_id,
          mapToDeletion,
          (value) => ({ ...value }),
        ),
        level: form.level !== undefined ? Number(form.level) || 0 : undefined,
        permit_reset_client_user_password_by_others: form.permit_reset_client_user_password_by_others,
      }

      return privateAxios.put(`/client/roles/${roleId}`, { ...payload })
    },
    onSuccess,
    onError,
  })
}
